var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHosSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2778_102088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8242 51.8477H21.1758V55.1517H85.8242V51.8477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6864 33.2582H59.1596V43.9981H65.2054V19.0713H59.1596V28.4414H47.6864V19.0713H41.6406V43.9981H47.6864V33.2582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7555 72.0938C49.0781 71.2584 48.0499 70.5283 48.0499 69.0908C48.0499 67.4802 49.5111 66.562 52.3948 66.562C56.5078 66.562 57.3351 68.2178 57.6907 69.4521H63.752C63.4659 66.5545 61.1466 62.1592 52.5958 62.1592C46.7047 62.1592 41.9113 64.703 41.9113 69.6779C41.9113 73.0195 43.4807 75.8268 52.132 77.3094C57.3815 78.205 58.5334 79.1684 58.5334 80.8844C58.5334 82.495 57.4124 83.6766 53.5391 83.6766C49.4029 83.6766 47.6788 82.2617 46.9675 80.1092H40.9062C41.6639 84.5948 45.1739 88.0794 52.9669 88.0794C61.3244 88.0794 64.7107 84.5873 64.7107 80.2672C64.7107 76.6546 63.2263 73.7947 53.7633 72.0938H53.7555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V107H107V0H0ZM101.959 101.965H5.03302V5.03503H101.959V101.965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2778_102088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosSquareLogo);
export default __webpack_public_path__ + "static/media/hos-square-logo.a12edaf9d0e2f0fd6653bff5ed3c8211.svg";
export { ForwardRef as ReactComponent };